import { Alert } from "@/components-v2/Alert";
import { VBox } from "@/components-v2/Box";
import { observer } from "mobx-react";

export const Warning = observer(function ({ message }: { message: string }) {
  return (
    <VBox>
      <Alert type="warning" message={message} />
    </VBox>
  );
});
